import { useContext } from "react";
import "./Header.scss";
import { AppContext, AppContextInterface } from "../../../contexts/AppContext";
import translate from "@/i18n/translate";
import { Link } from 'react-router-dom';

export default function Header({
  displayName,
  productView
}: {
  displayName: string | null;
  productView?: "planning" | "navigator";
}): JSX.Element {
  const queryString = window.location.search;

  const { institution, sysUser, breadcrumb } =
    useContext<AppContextInterface>(AppContext);
  const headerBody = () => {
    if (institution) {
      const { REDIRECT_URI } = runConfig;
      const showHomeBreadcrum =
        breadcrumb === "home" ||
        (sysUser &&
          sysUser.roles.includes("contributor") &&
          sysUser.roles.length === 1);

      const urlSuffix = queryString.includes("locale") ? `/${queryString}` : "";

      const academicOfficeUrl = `/insights/academic_office${urlSuffix}`;
      const homeUrl = `/insights/home${urlSuffix}`;

      const breadCrumbsUrl = showHomeBreadcrum ? homeUrl : academicOfficeUrl;

      return (
        <div className="page-banner -mainheader -withbreadcrumbs only-breadcrumbs no-shadow">
          <div className="" id="page-header">
            <section className="bread-crumbs -crumb">
              {productView === "planning" ? (
                <a
                  href={REDIRECT_URI}
                  id="link-0-page-banner"
                  className={displayName ? "link" : "link home-link"}
                >
                  <span className={"breadcrumb-title"}>
                    {translate("app.mainnav.home")}
                  </span>
                </a>
              ) : (
                <Link
                  to={breadCrumbsUrl}
                  id="link-0-page-banner"
                  className={displayName ? "link" : "link home-link"}
                >
                  <span className={"breadcrumb-title"}>
                    {showHomeBreadcrum
                      ? translate("app.mainnav.home")
                      : translate("app.mainnav.academicsAndOffices")}
                  </span>
                </Link>
              )}
              <span className="org-name">{displayName}</span>
            </section>

            <section className="identity-details institution-name-home">
              <div className="page-header -titleonly">
                <h2 id="main-heading" className="title -new-title">{displayName}</h2>
              </div>
            </section>
          </div>
        </div>
      );
    }
  };

  return <>{headerBody()}</>;
}

function UserIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99967 0.333008C3.31967 0.333008 0.333008 3.31967 0.333008 6.99967C0.333008 10.6797 3.31967 13.6663 6.99967 13.6663C10.6797 13.6663 13.6663 10.6797 13.6663 6.99967C13.6663 3.31967 10.6797 0.333008 6.99967 0.333008ZM6.99967 2.33301C8.10634 2.33301 8.99967 3.22634 8.99967 4.33301C8.99967 5.43967 8.10634 6.33301 6.99967 6.33301C5.89301 6.33301 4.99967 5.43967 4.99967 4.33301C4.99967 3.22634 5.89301 2.33301 6.99967 2.33301ZM6.99967 11.7997C5.33301 11.7997 3.85967 10.9463 2.99967 9.65301C3.01967 8.32634 5.66634 7.59967 6.99967 7.59967C8.32634 7.59967 10.9797 8.32634 10.9997 9.65301C10.1397 10.9463 8.66634 11.7997 6.99967 11.7997Z"
        fill="#575195"
      />
    </svg>
  );
}
